import React from "react"

import {
    Avatar,
    Button,
    Typography,
} from "@mui/material"
import {
    GridColDef,
    GridValueGetterParams,
} from "@mui/x-data-grid"

import {
    t,
    Trans,
} from "@lingui/macro"
import { Link } from "react-router-dom"


const defaultColumnDefinition: GridColDef = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getBrandTableColumns = (): GridColDef[] => {
    return [
        {
            ...defaultColumnDefinition,
            field: "brandImage",
            headerName: "",
            width: 100,
            renderCell: (params: { row: any }) => {
                if(params.row.logo === null) {
                    return (<Avatar sx={{fontSize: "0.7em"}}>No logo</Avatar>)
                } else {
                    return (<img src={params.row.logo} alt="logo" width={50} style={{borderRadius: 30}} />)
                }
            },
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "name",
            headerName: t({
                id: "brand-table.brand-name",
                message: "Brand",
                comment: "in brand table, brand name",
            }),
            flex: 1,
            sortable: true
        },
        {
            ...defaultColumnDefinition,
            field: "company",
            headerName: t({
                id: "brand-table.society",
                message: "Società",
                comment: "in brand table, society",
            }),
            flex: 1,
            sortable: true,
            valueGetter: (params: GridValueGetterParams) => {
                return params.row.company.name
            }
        },
        {
            ...defaultColumnDefinition,
            field: "products",
            headerName: t({
                id: "brand-table.category",
                message: "Categoria",
                comment: "in brand table, category",
            }),
            flex: 1.5,
            sortable: true,
            valueGetter: (params: GridValueGetterParams) => {
                let productList: string[] = []
                for(let j = 0; j < params.row.products.length; j++) {
                    productList.push(params.row.products[j].name)
                }

                return productList
            }
        },
        {
            ...defaultColumnDefinition,
            field: "activeContractsCount",
            headerName: t({
                id: "brand-table.active-openings",
                message: "Aperture attive"
            }),
            width: 100,
            flex: 0.75,
            sortable: true
        },
        {
            ...defaultColumnDefinition,
            field: "details",
            headerName: t({
                id: "brand-table.details",
                message: "Dettagli",
                comment: "in brand table, details",
            }),
            width: 200,
            renderCell: (params: { row: any }) => (
                <Link key="brandProfile" to={`/brand/${params.row.id}`}>
                    <Button
                        variant="contained"
                        disableElevation
                        sx={{
                            textTransform: 'none',
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            paddingX: 2,
                            height: 28,
                        }}>
                        <Typography>
                            <Trans id="brand-table.view-details">
                                Vedi dettagli
                            </Trans>
                        </Typography>
                    </Button>
                </Link>
            ),
            sortable: false
        },
    ]
}

export default getBrandTableColumns
